export const uk = {
    fatalError: 'Во время копирования произошла ошибка. Попробуйте позже'
};
